import * as ActionTypes from 'constants';

export const fetchClient = id => ({
	type: ActionTypes.FETCH_CLIENT,
  payload : { id }
});

export const clearClient = f => ({
  type : ActionTypes.CLEAR_CLIENT
});

export const deleteClient = client => ({
	type: ActionTypes.DELETE_CLIENT,
	payload: {client}
});

export const receiveClient = client => ({
  type: ActionTypes.RECEIVE_CLIENT,
  payload: client
});

export const newClientInteraction = interaction => ({
  type: ActionTypes.ADD_CLIENT_INTERACTION,
  payload: { interaction }
});

export const newClientTask = task => ({
  type: ActionTypes.ADD_CLIENT_TASK,
  payload: { task }
});

export const deleteClientTask = (task_id) => ({
	type : ActionTypes.DELETE_CLIENT_TASK,
	payload : {task_id}
})

export const updateClientTask = task => ({
  type: ActionTypes.UPDATE_CLIENT_TASK,
  payload: { task }
});

export const newIncident = incident => ({
  type: ActionTypes.CLIENT_NEW_INCIDENT,
  payload: { incident }
});

export const startCreatingClient = client_data => ({
	type : ActionTypes.SHOW_CREATE_CLIENT,
	payload : client_data
 });
export const stopCreatingClient = f => ({ type: ActionTypes.HIDE_CREATE_CLIENT });

export const updateCurrentPlace = (place) => ({
	type : ActionTypes.UPDATE_CURRENT_PLACE,
	payload : place
})



// WEBPACK FOOTER //
// ./src/common/actions/client.js